import { render, staticRenderFns } from "./handlerDataConfig.vue?vue&type=template&id=5580c4c8&"
import script from "./handlerDataConfig.vue?vue&type=script&lang=js&"
export * from "./handlerDataConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports